import { FeedbackCardContainer } from '@yes.technology/react-toolkit'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../asset/css/default.css'

import { useFeatureFlag, useHandleLanguage } from './hooks'
import AuthenticationRenewal from './AuthenticationRenewal'
import Chat from './Chat'
import EnvironmentAlert from './EnvironmentAlert'
import Loading from './Loading'
import NetworkDetector from './NetworkDetector'
import RedirectToLogin from './RedirectToLogin'
import Router from './Router'
import useToken from './useToken'
import useSetWorkflow from './Workflow'
import { useAppSelector } from 'state/store'

const HelloYes = () => {
  const isLoading = useAppSelector((state) => state.api.isPending)

  useHandleLanguage()
  useToken()
  useSetWorkflow()

  const [chatFlag] = useFeatureFlag('chat')
  const isChatEnabled =
    chatFlag !== null ? chatFlag : window.waYesChatConfig.enabled

  return (
    <>
      <Loading active={isLoading} />
      <AuthenticationRenewal />
      <RedirectToLogin />
      <EnvironmentAlert environment={window.waEnv} />
      <NetworkDetector />
      <Router />
      <FeedbackCardContainer />
      {isChatEnabled && <Chat />}
    </>
  )
}

export default HelloYes
